import type {GatsbyBrowser} from 'gatsby'

export const registerServiceWorker: GatsbyBrowser['registerServiceWorker'] = () =>
    process.env.GATSBY_ACTIVE_ENV !== 'production'
